import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { formatDateTimeFull } from '@app/common/util/i18n';
import styles from './automation-token-cell.css';
export function AutomationTokenDate(props) {
    const { date, expired } = props;
    return (_jsx("span", { className: classNames({ [styles.expiredDate]: expired }), children: formatDateTimeFull(date) }));
}
